import React, { useState } from "react";
import "../Styles/Home.css";
import logoMain from "../Assets/logoNH7.png";
import back from "../Assets/back.svg";
import dayOneTitle from "../Assets/lineup/dayOneTitle.png";
import dayTwoTitle from "../Assets/lineup/dayTwoTitle.png";
import dayThreeTitle from "../Assets/lineup/dayThreeTitle.png";
import DayOnePoster from "../Assets/lineup/dayOne.png";
import DayTwoPoster from "../Assets/lineup/dayTwo.png";
import DayThreePoster from "../Assets/lineup/dayThree.png";
import Accordion from 'react-bootstrap/Accordion';


const ArtistLineUp = () => {


  return (
    <div>
      <section className="height_custom">
        <div>
          <a href="/" className="fBack">
            <img src={back} className="backBtn" alt="back button"></img>
          </a>
        </div>
      <div className="content_div_lineup">
            <a href="/">
              <img src={logoMain} className="logoMain_pages" alt="nh7 Weekender logo"></img>
            </a>
             <div className="line_up_block">
                <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <img src={dayOneTitle} className="title_lineup" alt="day 1 title"></img>
                        </Accordion.Header>
                        <Accordion.Body>
                        <img src={DayOnePoster} className="lineup_poster" alt="day one schedule"></img>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>
                            <img src={dayTwoTitle} className="title_lineup" alt="day 2 title"></img>
                        </Accordion.Header>
                        <Accordion.Body>
                        <img src={DayTwoPoster} className="lineup_poster" alt="day two schedule"></img>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>
                            <img src={dayThreeTitle} className="title_lineup" alt="day 3 title"></img>
                        </Accordion.Header>
                        <Accordion.Body>
                        <img src={DayThreePoster} className="lineup_poster" alt="day three schedule"></img>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
             </div>
          </div>
      </section>
    </div>
  );
};

export default ArtistLineUp;
